module.exports = __webpack_public_path__ + "img/lupa.3e6e5f73.svg";